import { useState } from 'react';
import Modal from './Modal';
import './styles/module-artists.css';

// Platform SVG Icons
const PLATFORM_ICONS = {
  spotify: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 0C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141 4.32-1.32 9.72-.66 13.44 1.62.42.3.54.84.3 1.261zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.72 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
    </svg>
  ),
  bandcamp: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M0 18.75l7.437-13.5H24l-7.438 13.5H0z"/>
    </svg>
  ),
  soundcloud: (
    <svg width="20" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M1.175 12.225c-.047 0-.094.016-.125.047a.23.23 0 0 0-.047.141v5.188c0 .063.016.109.047.141.031.031.078.047.125.047h.453c.047 0 .094-.016.125-.047a.23.23 0 0 0 .047-.141v-5.188a.23.23 0 0 0-.047-.141.168.168 0 0 0-.125-.047h-.453zm1.609-1.844c-.063 0-.109.016-.141.047a.23.23 0 0 0-.047.141v7.031c0 .063.016.109.047.141.031.031.078.047.141.047h.453c.063 0 .109-.016.141-.047a.23.23 0 0 0 .047-.141v-7.031a.23.23 0 0 0-.047-.141.168.168 0 0 0-.141-.047h-.453zm1.625-1.781c-.063 0-.109.016-.141.047a.23.23 0 0 0-.047.141v8.813c0 .063.016.109.047.141.031.031.078.047.141.047h.453c.063 0 .109-.016.141-.047a.23.23 0 0 0 .047-.141V8.781a.23.23 0 0 0-.047-.141.168.168 0 0 0-.141-.047h-.453zm1.609-.844c-.063 0-.109.016-.141.047a.23.23 0 0 0-.047.141v9.656c0 .063.016.109.047.141.031.031.078.047.141.047h.453c.063 0 .109-.016.141-.047a.23.23 0 0 0 .047-.141V7.938a.23.23 0 0 0-.047-.141.168.168 0 0 0-.141-.047h-.453zm1.625 1.156c-.063 0-.109.016-.141.047a.23.23 0 0 0-.047.141v8.5c0 .063.016.109.047.141.031.031.078.047.141.047h.453c.063 0 .109-.016.141-.047a.23.23 0 0 0 .047-.141v-8.5a.23.23 0 0 0-.047-.141.168.168 0 0 0-.141-.047h-.453zm1.609-2.094c-.063 0-.109.016-.141.047a.23.23 0 0 0-.047.141v10.594c0 .063.016.109.047.141.031.031.078.047.141.047h.453c.063 0 .109-.016.141-.047a.23.23 0 0 0 .047-.141V7c0-.063-.016-.109-.047-.141a.168.168 0 0 0-.141-.047h-.453zm1.625-1.578c-.063 0-.109.016-.141.047a.23.23 0 0 0-.047.141v12.172c0 .063.016.109.047.141.031.031.078.047.141.047h.453c.063 0 .109-.016.141-.047a.23.23 0 0 0 .047-.141V5.422a.23.23 0 0 0-.047-.141.168.168 0 0 0-.141-.047h-.453zm7.047 1.844c-1.078 0-2.078.375-2.859 1.016-.078.063-.125.109-.156.141v9.203c0 .063.016.109.047.141.031.031.078.047.141.047h10.453c1.516 0 2.75-1.234 2.75-2.75s-1.234-2.75-2.75-2.75c-.219 0-.422.031-.625.078C20.688 8.656 18.281 7 15.391 7z"/>
    </svg>
  ),
  youtube: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>
  ),
  twitter: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.936 9.936 0 0024 4.59z"/>
    </svg>
  ),
  bluesky: (
    <svg width="18" height="18" viewBox="-30 -30 628 561" fill="currentColor">
      <path d="M123.121 33.664C187.857 82.201 254.345 174.62 284 227.054c29.655-52.434 96.143-144.853 160.879-193.39C491.564 0 568 6.223 568 96.155c0 19.92-2.584 40.09-8.082 60.106-18.79 68.397-88.75 142.115-168.082 173.805 138.835 24.364 163.766 99.309 95.836 177.304-129.176 148.314-188.086-34.908-203.672-88.37-15.586 53.462-74.496 236.684-203.672 88.37-67.93-77.995-43-152.94 95.836-177.304C96.832 298.376 26.872 224.658 8.082 156.261 2.584 136.245 0 116.075 0 96.155 0 6.223 76.436 0 123.121 33.664z"/>
    </svg>
  ),
  instagram: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  ),
  apple: (
    <svg width="18" height="18" viewBox="50 45 225 270" fill="currentColor">
      <path d="M254.5,55c-0.87,0.08-8.6,1.45-9.53,1.64l-107,21.59l-0.04,0.01c-2.79,0.59-4.98,1.58-6.67,3c-2.04,1.71-3.17,4.13-3.6,6.95c-0.09,0.6-0.24,1.82-0.24,3.62c0,0,0,109.32,0,133.92c0,3.13-0.25,6.17-2.37,8.76c-2.12,2.59-4.74,3.37-7.81,3.99c-2.33,0.47-4.66,0.94-6.99,1.41c-8.84,1.78-14.59,2.99-19.8,5.01c-4.98,1.93-8.71,4.39-11.68,7.51c-5.89,6.17-8.28,14.54-7.46,22.38c0.7,6.69,3.71,13.09,8.88,17.82c3.49,3.2,7.85,5.63,12.99,6.66c5.33,1.07,11.01,0.7,19.31-0.98c4.42-0.89,8.56-2.28,12.5-4.61c3.9-2.3,7.24-5.37,9.85-9.11c2.62-3.75,4.31-7.92,5.24-12.35c0.96-4.57,1.19-8.7,1.19-13.26l0-116.15c0-6.22,1.76-7.86,6.78-9.08c0,0,88.94-17.94,93.09-18.75c5.79-1.11,8.52,0.54,8.52,6.61l0,79.29c0,3.14-0.03,6.32-2.17,8.92c-2.12,2.59-4.74,3.37-7.81,3.99c-2.33,0.47-4.66,0.94-6.99,1.41c-8.84,1.78-14.59,2.99-19.8,5.01c-4.98,1.93-8.71,4.39-11.68,7.51c-5.89,6.17-8.49,14.54-7.67,22.38c0.7,6.69,3.92,13.09,9.09,17.82c3.49,3.2,7.85,5.56,12.99,6.6c5.33,1.07,11.01,0.69,19.31-0.98c4.42-0.89,8.56-2.22,12.5-4.55c3.9-2.3,7.24-5.37,9.85-9.11c2.62-3.75,4.31-7.92,5.24-12.35c0.96-4.57,1-8.7,1-13.26V64.46C263.54,58.3,260.29,54.5,254.5,55z"/>
    </svg>
  ),
  applemusic: (
    <svg width="18" height="18" viewBox="50 45 225 270" fill="currentColor">
      <path d="M254.5,55c-0.87,0.08-8.6,1.45-9.53,1.64l-107,21.59l-0.04,0.01c-2.79,0.59-4.98,1.58-6.67,3c-2.04,1.71-3.17,4.13-3.6,6.95c-0.09,0.6-0.24,1.82-0.24,3.62c0,0,0,109.32,0,133.92c0,3.13-0.25,6.17-2.37,8.76c-2.12,2.59-4.74,3.37-7.81,3.99c-2.33,0.47-4.66,0.94-6.99,1.41c-8.84,1.78-14.59,2.99-19.8,5.01c-4.98,1.93-8.71,4.39-11.68,7.51c-5.89,6.17-8.28,14.54-7.46,22.38c0.7,6.69,3.71,13.09,8.88,17.82c3.49,3.2,7.85,5.63,12.99,6.66c5.33,1.07,11.01,0.7,19.31-0.98c4.42-0.89,8.56-2.28,12.5-4.61c3.9-2.3,7.24-5.37,9.85-9.11c2.62-3.75,4.31-7.92,5.24-12.35c0.96-4.57,1.19-8.7,1.19-13.26l0-116.15c0-6.22,1.76-7.86,6.78-9.08c0,0,88.94-17.94,93.09-18.75c5.79-1.11,8.52,0.54,8.52,6.61l0,79.29c0,3.14-0.03,6.32-2.17,8.92c-2.12,2.59-4.74,3.37-7.81,3.99c-2.33,0.47-4.66,0.94-6.99,1.41c-8.84,1.78-14.59,2.99-19.8,5.01c-4.98,1.93-8.71,4.39-11.68,7.51c-5.89,6.17-8.49,14.54-7.67,22.38c0.7,6.69,3.92,13.09,9.09,17.82c3.49,3.2,7.85,5.56,12.99,6.6c5.33,1.07,11.01,0.69,19.31-0.98c4.42-0.89,8.56-2.22,12.5-4.55c3.9-2.3,7.24-5.37,9.85-9.11c2.62-3.75,4.31-7.92,5.24-12.35c0.96-4.57,1-8.7,1-13.26V64.46C263.54,58.3,260.29,54.5,254.5,55z"/>
    </svg>
  ),
  website: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  site: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  )
};

export default function ArtistCard({ artist }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    id,
    name,
    photo,
    bannerImage,
    genres = [],
    comment,
    links = {},
    previews = []
  } = artist;

  const hasComment = comment && comment.trim().length > 0;
  const displayPhoto = photo || bannerImage;

  // Filter valid platform links
  const validLinks = Object.entries(links).filter(([_, linkData]) => {
    if (!linkData) return false;
    const url = typeof linkData === 'string' ? linkData : linkData.url;
    return Boolean(url && url.trim().length > 0);
  });

  const hasLinks = validLinks.length > 0;
  const hasPreviews = previews && previews.length > 0;
  const hasGenres = genres && genres.length > 0;

  // If no links, comment, genres, or previews exist, modal should not pop up
  const isExpandable = hasComment || hasLinks || hasPreviews || hasGenres || Boolean(displayPhoto);

  const handleCardClick = () => {
    if (isExpandable) {
      setIsModalOpen(true);
    }
  };

  return (
    <>
      {/* Mini Card — Concept C: Full Photo Card with Bottom Dark Gradient Overlay */}
      <div
        className={`artist-card ${!isExpandable ? 'non-expandable' : ''}`}
        onClick={handleCardClick}
        style={{ cursor: isExpandable ? 'pointer' : 'default' }}
      >
        {photo ? (
          <img src={photo} alt={name} className="artist-photo-full" />
        ) : (
          <div className="artist-photo-placeholder-full">{name.charAt(0)}</div>
        )}

        <div className="artist-card-overlay">
          <h3 className="artist-card-title">{name}</h3>
        </div>
      </div>

      {/* Pop-Out Detail & Preview Modal */}
      {isExpandable && (
        <Modal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>

            {/* Hero Section — Photo on left, Meta & Platform Links on right */}
            <div className="artist-modal-hero">
              {displayPhoto && (
                <img src={displayPhoto} alt={name} className="artist-modal-cover" />
              )}

              <div className="artist-modal-meta">
                <h2 className="artist-modal-name">{name}</h2>

                {hasGenres && (
                  <div className="artist-genres">
                    {genres.map((genre, idx) => (
                      <span key={idx} className="genre-chip">{genre}</span>
                    ))}
                  </div>
                )}

                {/* Platform Links — Square Icon Buttons */}
                {hasLinks && (
                  <div className="artist-platform-links">
                    {validLinks.map(([key, linkData]) => {
                      const url = typeof linkData === 'string' ? linkData : linkData.url;
                      const icon = PLATFORM_ICONS[key] || PLATFORM_ICONS.website;

                      return (
                        <a
                          key={key}
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`platform-square-btn ${key}`}
                          title={`Open ${name} on ${key}`}
                        >
                          {icon}
                        </a>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>

            <hr className="about-divider" style={{ margin: '0.25rem 0' }} />

            {/* Commentary Section */}
            <div>
              <h4 className="artist-section-label">My Thoughts</h4>
              <p className="artist-comment-text">
                {hasComment ? comment : 'No thoughts written yet.'}
              </p>
            </div>

            {/* Music Previews Section */}
            {hasPreviews && (
              <div>
                <h4 className="artist-section-label">Music Previews</h4>
                <div className="artist-previews-list">
                  {previews.map((preview, idx) => (
                    <div key={idx} className="artist-preview-item">
                      {preview.embedUrl && (
                        <iframe
                          src={preview.embedUrl}
                          width="100%"
                          height={preview.height || '152'}
                          frameBorder="0"
                          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                          loading="lazy"
                          style={{ borderRadius: '12px', border: 'none' }}
                          title={`${name} track preview ${idx + 1}`}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

          </div>
        </Modal>
      )}
    </>
  );
}
